<template>
  <div class="wrap-banner">
    <Logo />
    <Carousel />
  </div>
</template>

<script>
const Logo = () => import('./Logo')
const Carousel = () => import('./Carousel')

export default {
  components: {
    Logo,
    Carousel
  }
}
</script>
